"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.captureConsoleIntegration = void 0;

var _currentScopes = require("../currentScopes.js");

var _exports = require("../exports.js");

var _integration = require("../integration.js");

var _console = require("../utils-hoist/instrument/console.js");

var _logger = require("../utils-hoist/logger.js");

var _misc = require("../utils-hoist/misc.js");

var _severity = require("../utils-hoist/severity.js");

var _string = require("../utils-hoist/string.js");

var _worldwide = require("../utils-hoist/worldwide.js");

const INTEGRATION_NAME = 'CaptureConsole';

const _captureConsoleIntegration = (options = {}) => {
  const levels = options.levels || _logger.CONSOLE_LEVELS; // TODO(v9): Flip default value to `true`

  const handled = !!options.handled;
  return {
    name: INTEGRATION_NAME,

    setup(client) {
      if (!('console' in _worldwide.GLOBAL_OBJ)) {
        return;
      }

      (0, _console.addConsoleInstrumentationHandler)(({
        args,
        level
      }) => {
        if ((0, _currentScopes.getClient)() !== client || !levels.includes(level)) {
          return;
        }

        consoleHandler(args, level, handled);
      });
    }

  };
};
/**
 * Send Console API calls as Sentry Events.
 */


const captureConsoleIntegration = exports.captureConsoleIntegration = (0, _integration.defineIntegration)(_captureConsoleIntegration);

function consoleHandler(args, level, handled) {
  const captureContext = {
    level: (0, _severity.severityLevelFromString)(level),
    extra: {
      arguments: args
    }
  };
  (0, _currentScopes.withScope)(scope => {
    scope.addEventProcessor(event => {
      event.logger = 'console';
      (0, _misc.addExceptionMechanism)(event, {
        handled,
        type: 'console'
      });
      return event;
    });

    if (level === 'assert') {
      if (!args[0]) {
        const message = `Assertion failed: ${(0, _string.safeJoin)(args.slice(1), ' ') || 'console.assert'}`;
        scope.setExtra('arguments', args.slice(1));
        (0, _exports.captureMessage)(message, captureContext);
      }

      return;
    }

    const error = args.find(arg => arg instanceof Error);

    if (error) {
      (0, _exports.captureException)(error, captureContext);
      return;
    }

    const message = (0, _string.safeJoin)(args, ' ');
    (0, _exports.captureMessage)(message, captureContext);
  });
}